import { Box, Flex, DeprecatedIcon, Typography } from '@fullstory/components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './userContext.module.scss';

interface UserContextProps {
  location: string;
  device: string;
  integrationName: string;
  os: string;
  isServerOnly: boolean;
}
const UserContext: React.FC<UserContextProps> = ({
  device,
  location,
  integrationName,
  os,
  isServerOnly,
}) => (
  <Flex data-component="UserContext" className={css.userContext} alignItems="center">
    <Box className="details" width={1}>
      <Typography variant="body3" color="neutrals-n10" textAlign="right">
        {location ||
          (isServerOnly ? (
            <FormattedMessage defaultMessage="Server" id="F/6VqP" />
          ) : (
            <FormattedMessage defaultMessage="Unknown" id="5jeq8P" />
          ))}
      </Typography>
      <Box paddingBottom={4}>
        <Flex justifyContent="flex-end">
          <Box paddingRight={4}>
            <Typography color="neutrals-n7" variant="heading7" ellipsize tag="div">
              {isServerOnly ? integrationName : `${device} · ${os}`}
            </Typography>
          </Box>
          <DeprecatedIcon
            name={getDeviceIcon(!isServerOnly ? device : 'Server')}
            color="neutrals-n6"
            size={16}
          />
        </Flex>
      </Box>
    </Box>
  </Flex>
);

const getDeviceIcon = (device: string): React.ComponentProps<typeof DeprecatedIcon>['name'] => {
  switch (device) {
    case 'Mobile':
      return 'device-mobile';
    case 'Tablet':
      return 'device-tablet';
    case 'Desktop':
      return 'device-desktop';
    case 'Robot':
      return 'device-robot';
    case 'Server':
      return 'device-server';
    case 'Unknown':
      return 'device-unknown';
  }
  return 'device-unknown';
};

export default UserContext;
